import React from 'react';
//Components
import Home from './components/Home';
//style
import {GlobalStyle} from './GlobalStyle';

const App = ()  => (
  <>
  <Home/>
  <GlobalStyle></GlobalStyle>
  </>
)

export default App;
